import React from "react";

const Home = () => (
    <div style={styles.container}>
        <img
        style={styles.imageCover}
        src="https://image.freepik.com/free-photo/nordic-blue-simple-indoor-home-background_149197-9.jpg"
        alt="belajar coding"
        />
        <div style={styles.blockText}>
            <h1>Belajar Coding Sekarang</h1>
            <h4>
                Lebih dari 2.000 modul belajar pemrograman dalam beragam format yang bisa kamu pelajari.
            </h4>
        </div>
    </div>
);

const styles = {
    container: {
        position: 'relative',
        textAlign: 'center',
    },
    imageCover: {
        width: '100%'
    },
    blockText: {
        width: '100%',
        position: 'absolute',
        top: '30%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white'
    }
}

export default Home;